"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDictationInterimsStyle;

function createDictationInterimsStyle(_ref) {
  var paddingRegular = _ref.paddingRegular,
      primaryFont = _ref.primaryFont;
  return {
    fontFamily: primaryFont,
    margin: 0,
    paddingBottom: 0,
    paddingLeft: paddingRegular,
    paddingRight: paddingRegular,
    paddingTop: 0,
    '&.dictating > span:not(:first-child), &.status': {
      opacity: 0.5
    }
  };
}